import packageFile from '../../package.json'
import os from 'os'
import { jwtDecode } from 'jwt-decode'
import { Log } from './logger'
import { APP_AUTH_NAME } from '../constants'
import { isEmpty } from 'lodash'

export const DEBUG = 'debug'
export const CRITICAL = 'critical'
export const INFO = 'information'
export const WARNING = 'warning'
export const ERROR = 'error'

const createOffset = date => {
  const sign = date.getTimezoneOffset() > 0 ? '-' : '+'
  const offset = Math.abs(date.getTimezoneOffset())
  const hours = `${Math.floor(offset / 60)}`.padStart(2, 0)
  const minutes = `${offset % 60}`.padStart(2, '0')
  return `${sign + hours}.${minutes}`
}

export const errorCategories = {
  400: 'BAD_REQUEST',
  401: 'UNAUTHORIZED',
  403: 'FORBIDDEN',
  404: 'NOT_FOUND',
  405: 'METHOD_NOT_ALLOWED',
  408: 'REQUEST_TIMEOUT',
  409: 'CONFLICT',
  422: 'UNPROCESSABLE_CONTENT',
  429: 'TOO_MANY_REQUESTS',
  500: 'INTERNAL_SERVER',
  502: 'BAD_GATEWAY',
  503: 'SERVICE_UNAVAILABLE',
  504: 'GATEWAY_TIMEOUT'
}
export const MODULE_NAME = 'EMBARKATION_ADMIN_UI'
const getClientIp = req =>
  (
    req.ip ||
    req.headers['x-forwarded-for'] ||
    req.connection.remoteAddress ||
    ''
  )
    .split(',')[0]
    .trim()
export const getDeviceInfo = (req = {}) => {
  const deviceInfo = {}
  let ip = null
  if (!req.headers) {
    const networkInterface = os.networkInterfaces()
    ip = () => {
      if (networkInterface.eth0) {
        return networkInterface.eth0[0] ? networkInterface.eth0[0].address : ''
      } else if (networkInterface.en1) {
        return networkInterface.en1[1] ? networkInterface.en1[1].address : ''
      }
      return ''
    }
  }
  deviceInfo.name = os.hostname()
  deviceInfo.id = ip || getClientIp(req)
  deviceInfo.operatingSystem = os.type()
  deviceInfo.osVersion = os.release()
  return deviceInfo
}

export const kibanaLog = ({
  message = '',
  variables = '',
  stack = '',
  logLevel = 'error',
  messageCode = 1004,
  req = undefined,
  categoryCode = 404
}) => {
  let msg = message
  if (variables) {
    msg += ` \nVariables: ${JSON.stringify(variables)}`
  }
  if (process.env.NODE_ENV !== 'production') {
    const commonErrorLogInfo = {
      // the key names here form request body so the names are to be used as is
      name: 'crew',
      componentName: 'dxpembarkationadminui',
      severity: 'ERROR' // since we are not logging anything else
    }
    const time = new Date().toISOString()
    const stackTrace = stack ? { stackTrace: stack } : {}
    const componentVersion = packageFile.version
    const hostName = os.hostname()
    const category = errorCategories[categoryCode]
    const accessToken = localStorage.getItem(APP_AUTH_NAME)?.token
    const decodedAccessToken = !isEmpty(accessToken)
      ? jwtDecode(accessToken)
      : {}
    const request = {
      ...commonErrorLogInfo,
      hostName,
      message: msg,
      messageCode,
      messageDetail: JSON.stringify({ tag: MODULE_NAME }),
      timestamp: time,
      time,
      offset: createOffset(new Date()),
      logLevel,
      componentVersion,
      deviceInfo: getDeviceInfo(req),
      callerAppId: decodedAccessToken?.appid || null,
      callerType: decodedAccessToken?.usertype || null,
      jti: decodedAccessToken?.jti || null,
      category,
      ...stackTrace
    }
    Log(request)
  }
}
